
import { useQuery } from '@tanstack/react-query';
import { enhancedSitemapService } from '@/services/enhancedSitemapService';

export const useSitemap = () => {
  return useQuery({
    queryKey: ['sitemap'],
    queryFn: () => enhancedSitemapService.generateSitemap(),
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours
    retry: 2,
  });
};

export const useSitemapGeneration = () => {
  return useQuery({
    queryKey: ['sitemap-generation'],
    queryFn: () => enhancedSitemapService.saveSitemapToFile(),
    enabled: false, // Only run when manually triggered
    retry: 1,
  });
};
